<script>
import ELEMENT from 'element-ui';
import countlyVue from '../../compat/vue-core';
import triggerProxy from './trigger-proxy.vue';

export default countlyVue.components.BaseComponent.extend({
  name: 'ClyDropdown',
  components: {
    'trigger-proxy': triggerProxy,
    'el-select-dropdown': ELEMENT.SelectDropdown,
  },
  mixins: [ELEMENT.utils.Emitter],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    popperAppendToBody: {
      type: Boolean,
      default: true,
    },
    width: {
      type: [Number, Object],
      default: null,
    },
    placement: {
      type: String,
      default: 'bottom-start',
    },
    popClass: {
      type: String,
    },
    isOpen: {
      type: Boolean,
      required: false,
    },
  },
  inject: {
    popperAncestors: {
      default() {
        return {};
      },
    },
  },
  computed: {
    popperUid() {
      return `popper-${this.componentId}`;
    },
    popperClass() {
      return `cly-vue-dropdown__pop${this.popClass ? ` ${this.popClass}` : ''}`;
    },
  },
  provide() {
    const history = { ...this.popperAncestors };
    history[this.popperUid] = true;
    return {
      popperAncestors: history,
    };
  },
  data() {
    return {
      visible: false,
      focused: false,
    };
  },
  beforeDestroy() {
    this.broadcast('ElSelectDropdown', 'destroyPopper');
    if (this.$refs.popper) {
      this.$refs.popper.doDestroy();
    }
  },
  methods: {
    doClose(aborted) {
      if (this.visible) {
        this.visible = false;
        this.$emit('hide', aborted);
      }
    },
    handleOutsideClick() {
      this.doClose(true);
      this.focused = false;
    },
    handleClose(aborted) {
      this.doClose(aborted);
    },
    handleOpen() {
      if (!this.disabled && !this.visible) {
        this.visible = true;
      }
    },
    handleToggle() {
      if (this.disabled && !this.visible) {
        return;
      }
      this.visible = !this.visible;
      if (!this.visible) {
        this.$emit('hide', true);
      }
    },
    updateDropdown() {
      this.$nextTick(() => {
        this.broadcast('ElSelectDropdown', 'updatePopper');
      });
    },
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        this.$emit('show');
        this.focused = true;
      }
    },
  },
});
</script>
<template>
  <div
    v-click-outside="handleOutsideClick"
    class="cly-vue-dropdown el-select !shadow-none"
  >
    <trigger-proxy
      ref="reference"
      @click.native.stop="handleToggle"
      @keydown.native.esc.stop.prevent="handleClose(true)"
      @keydown.native.down.enter.prevent="handleOpen"
      @keydown.native.down.stop.prevent="handleOpen"
      @keydown.native.up.stop.prevent="handleOpen"
    >
      <slot
        name="trigger"
        :visible="visible"
        :focused="focused"
      />
    </trigger-proxy>
    <el-select-dropdown
      v-show="visible"
      ref="popper"
      v-model="visible"
      class="w-fit p-0 !border-warm-gray-30 shadow-sm"
      :width="width"
      :append-to-body="popperAppendToBody"
      :placement="placement"
      :visible-arrow="false"
    >
      <div
        ref="popContent"
        class="word-break-normal"
      >
        <slot />
      </div>
    </el-select-dropdown>
  </div>
</template>
